import { deriveUnitsPerPack } from '@/experiences/sales-portal/domain/pricing/screens/quotes/blocs/utils/units-per-pack';
import { PriceQuotesSavedDetailQuery } from '@/types';
import { QuoteLineItem } from '@/experiences/sales-portal/domain/pricing/screens/quotes/blocs/hooks/use-quote-state-types';

const MICROS_PER_UNIT = 1_000_000;

const microsToString = (micros: number): string =>
  (micros / MICROS_PER_UNIT).toString();

/**
 * Maps a server `GetPriceQuoteLineItem` into the editor's `QuoteLineItem`
 * shape: snake_case → camelCase, micros → displayable string prices,
 * `line_item_id` → `localId`, `sortOrder` derived from array index.
 *
 * @param raw   Server line item from the saved-quote detail response.
 * @param index Array position; becomes the line's `sortOrder`.
 */
export const toQuoteLineItem = (
  raw: PriceQuotesSavedDetailQuery['getPriceQuote']['line_items'][number],
  index: number,
): QuoteLineItem => ({
  competitor: raw.competitor
    ? {
        itemName: raw.competitor.item_name,
        packSize: raw.competitor.pack_size ?? undefined,
        price: microsToString(raw.competitor.pack_price_in_micros),
      }
    : undefined,
  currencyCode: raw.currency_code,
  isCatalogItemRemoved: raw.is_catalog_item_removed,
  itemCode: raw.item_code ?? undefined,
  itemDescription: raw.item_description ?? undefined,
  itemName: raw.item_name,
  itemPackSize: raw.item_pack_size ?? undefined,
  localId: raw.line_item_id,
  ourPrice: microsToString(raw.pack_price_in_micros),
  quantity: String(raw.quantity),
  sortOrder: index,
  unitsPerPack: deriveUnitsPerPack(
    raw.pack_price_in_micros,
    raw.per_unit_price_in_micros,
  ),
  variantPackId: raw.variant_pack_id ?? undefined,
});
